import {
  Event,
  EventBreakoutRoom,
  EventCommunications,
  EventFundraising,
  EventOndemandContent,
  EventPaymentProcessor,
  EventSponsor,
  EventStage,
  EventTicket,
  EventTicketDiscount,
} from '@graphql/__generated/graphql'
import { CreateEventStage } from '@libs/CreateEvent/CreateEventStage'
import { Maybe } from 'graphql/jsutils/Maybe'
import { createContext } from 'react'
import { ValidationRules } from './Utility/validation'

export interface EventCreation
  extends Omit<Event, 'stages' | 'breakoutRooms' | 'tickets' | 'sponsors'> {
  breakoutRooms?: Maybe<
    Array<
      Omit<EventBreakoutRoom, 'channelName' | 'token' | 'users' | 'totalUsers'>
    >
  >
  stages?: Maybe<
    Array<Omit<EventStage, 'channelName' | 'token' | 'grToken' | 'isLive'>>
  >
  tickets?: Maybe<Array<Omit<EventTicket, 'adminFee'>>>
  sponsors?: Maybe<Array<EventSponsor>>
  communications?: Maybe<EventCommunications>
  ondemandContent?: Maybe<Array<EventOndemandContent>>
  fundraising?: Maybe<EventFundraising>
  discounts?: Maybe<Array<EventTicketDiscount>>
  paymentProcessor?: Maybe<EventPaymentProcessor>
}

export interface CreateEventStageInfo {
  stage: keyof CreateEventStage | string
  skipPreview?: boolean
}

export type FormError = {
  step: string
  message: string
  eleId?: string
  alert?: boolean
}

export type CreateEventContextProps = {
  formData: Partial<EventCreation> | undefined
  setFormData: (data: Partial<EventCreation>) => void
  createEventStage?: CreateEventStageInfo
  setCreateEventStage: (data: CreateEventStageInfo) => void
  errors: FormError[]
  setErrors: (errors: FormError[]) => void
  validationRules: ValidationRules
  refetchEvent: () => any
  hasDirtyChanges?: boolean
  paymentSelectionReady?: boolean
  paymentSettingsLoading?: boolean
}

export const CreateEventContext = createContext<CreateEventContextProps>({
  setFormData: () => {},
  formData: {
    tickets: [],
    discounts: [],
    registrationFields: [],
    speakers: [],
    stages: [],
    sessions: [],
    attendees: [],
    sponsors: [],
    breakoutRooms: [],
    communications: {},
    ondemandContent: [],
    fundraising: {},
    notifications: [],
    emailTemplates: [],
  },
  setCreateEventStage: () => {},
  createEventStage: undefined,
  setErrors: () => {},
  errors: [],
  validationRules: [],
  refetchEvent: () => {},
  hasDirtyChanges: false,
  paymentSelectionReady: false,
  paymentSettingsLoading: false,
})
